const alerts = {
  moduleTitle: "Alerts",
  nav: {
    log: "Alert History",
  },
  actions: {
    view: "View",
    create: "Create",
    update: "Update",
    delete: "Delete",
  },
  priorities: {
    VERY_HIGH: "Very high",
    HIGH: "High",
    MEDIUM: "Medium",
    LOW: "Low",
  },
  status: {
    ACTIVE: "Active",
    INACTIVE: "Inactive",
  },
  list: {
    title: "Alert Management",
    subtitle:
      "View, edit and duplicate device, sensor and asset alerts in real time.",
    toolbar: {
      search: "Search",
      searchPlaceholder: "Search...",
      add: "Add alert",
    },
    filters: {
      filters: "Filters",
      type: "Alert type",
      assignmentType: "Assignment type",
      priority: "Priority",
      status: "Status",
      all: "All",
    },
    table: {
      company: "Company name",
      name: "Alert name",
      type: "Alert type",
      priority: "Priority",
      assignmentType: "Assignment type",
      status: "Status",
      empty: "No alerts found.",
      error: "Failed to load alerts.",
      loading: "Loading alerts",
      total: "Total {{total}} alerts",
      rowsPerPageLabel: "Rows per page",
      nextPage: "Next page",
      previousPage: "Previous page",
      pagination: "Rows per page",
      sortAscending: "Sort ascending",
      sortDescending: "Sort descending",
      actionMenu: "Actions",
    },
    actions: {
      view: "View",
      update: "Update",
      delete: "Delete",
    },
    deleteDialog: {
      title: "Delete",
      question: "Are you sure you want to delete this alert?",
      warning: "This action cannot be undone.",
      confirmWord: "Delete",
      instruction: 'Type "{{word}}" to confirm deletion',
      inputLabel: "Deletion confirmation",
      cancel: "Cancel",
      confirm: "Delete",
      close: "Close delete dialog",
      success: "Alert deleted successfully.",
    },
  },
  detail: {
    subtitle:
      "Alert configuration, trigger conditions, recipients and active schedule.",
    backToList: "Back to alerts",
    edit: "Edit",
    loading: "Loading alert",
    loadError: "Failed to load the alert.",
    notAvailable: "-",
    sections: {
      general: "General information",
      trigger: "Alert conditions",
      assignment: "Assignment",
      schedule: "Schedule",
      recipients: "Alert recipients",
    },
    fields: {
      company: "Company name",
      name: "Alert name",
      type: "Alert type",
      priority: "Priority",
      status: "Status",
      description: "Notes",
      assignmentType: "Assignment type",
      assignmentValue: "Assigned to",
      minTemperature: "Minimum temperature",
      maxTemperature: "Maximum temperature",
      minHumidity: "Minimum humidity",
      maxHumidity: "Maximum humidity",
      minWeight: "Minimum weight",
      maxWeight: "Maximum weight",
      alertValue: "Alert value",
      sensor: "Sensor",
      operator: "Operator",
      value: "Value",
      unit: "Unit",
      alwaysActive: "Always active",
      activeDays: "Active days",
      startTime: "Start time",
      endTime: "End time",
      startDate: "Start date",
      endDate: "End date",
      watchedAssets: "Watched assets",
      allAssets: "All assets",
    },
    binary: {
      on: "On",
      off: "Off",
    },
    yes: "Yes",
    no: "No",
    noRecipients: "No recipients",
    moreRecipients: "{{count}} more recipients",
  },
  targetTypes: {
    ASSET_TYPE: "Asset type",
    ASSET: "Specific assets",
    DEVICE_TYPE: "Device type",
    DEVICE: "Specific devices",
    GEOFENCE: "Geofences",
  },
  days: {
    SATURDAY: "Saturday",
    SUNDAY: "Sunday",
    MONDAY: "Monday",
    TUESDAY: "Tuesday",
    WEDNESDAY: "Wednesday",
    THURSDAY: "Thursday",
    FRIDAY: "Friday",
  },
  create: {
    title: "Add Alert",
    subtitle:
      "Configure the rules, technical conditions, targets and schedule of alert packages.",
    back: "Back to alerts",
    save: "Save",
    cancel: "Cancel",
    success: "Alert created successfully.",
    duplicateName: "Alert Name already exists.",
    optional: "(optional)",
    sections: {
      general: "General information",
      trigger: "Alert conditions",
      assignment: "Assignment",
      schedule: "Activity schedule",
      notifications: "Settings and notifications",
    },
    fields: {
      company: "Company name",
      companyPlaceholder: "Select a company",
      name: "Alert name",
      nameArPlaceholder: "Alert name in Arabic",
      nameEnPlaceholder: "Alert name in English",
      category: "Alert type",
      categoryPlaceholder: "Select an alert type",
      priority: "Priority",
      priorityPlaceholder: "Select a priority",
      description: "Alert description",
      descriptionPlaceholder: "Enter the alert description",
      maxSpeed: "Maximum speed (km/h)",
      downtimeMinutes: "Down time in minutes",
      minTemperature: "Minimum temperature",
      maxTemperature: "Maximum temperature",
      minHumidity: "Minimum humidity",
      maxHumidity: "Maximum humidity",
      minWeight: "Minimum weight",
      maxWeight: "Maximum weight",
      alertValue: "Expected digital sensor state",
      sensorType: "Sensor type",
      sensorTypePlaceholder: "Select a sensor type",
      operator: "Operator",
      operatorPlaceholder: "Select an operator",
      thresholdValue: "Threshold value",
      thresholdValueTo: "To value",
      unit: "Unit",
      unitPlaceholder: "e.g. c",
      triggerHint: "Select an alert type to show its conditions.",
      driverBehaviourHint:
        "Raised whenever the driver-monitoring camera detects this behaviour; there are no conditions to set.",
      geofenceCrossingHint:
        "Raised when an asset crosses the boundary of one of the alert's geofences; there are no conditions to set.",
      targetType: "Assignment type",
      targetTypePlaceholder: "Select an assignment type",
      branch: "Branch",
      branchPlaceholder: "Select a branch",
      targets: "Items covered by the alert",
      geofences: "Geofence names",
      watchedAssets: "Assets",
      watchedAssetsPlaceholder: "Select one or more assets",
      watchedAssetsHint: "Leave empty to watch every asset of the company.",
      targetsPlaceholder: {
        ASSET_TYPE: "Select one or more asset types",
        ASSET: "Select one or more assets",
        DEVICE_TYPE: "Select one or more device types",
        DEVICE: "Select one or more devices",
        GEOFENCE: "Select one or more geofences",
      },
      allAssetTypes: "All asset types",
      targetsNoBranch: "Select a branch first",
      targetsNoType: "Select an assignment type first",
      alwaysActive: "Always active",
      activeDays: "Active days",
      activeDaysPlaceholder: "Select one or more days",
      repeatWeekly: "Repeat weekly",
      startTime: "Daily start time",
      endTime: "Daily end time",
      startDate: "Start date",
      endDate: "End date",
      datePlaceholder: "Select a date",
      nextMonth: "Next month",
      previousMonth: "Previous month",
      recipients: "Alert recipients",
      recipientsPlaceholder: "Select recipients",
      recipientsHint: "You can select more than one recipient",
      selectCompanyFirst: "Select a company first",
      search: "Search…",
      empty: "No results",
      loading: "Loading",
      remove: "Remove {{name}}",
    },
    binary: {
      ON: "On",
      OFF: "Off",
    },
    operators: {
      GREATER_THAN: "Greater than >",
      GREATER_THAN_OR_EQUAL: "Greater than or equal ≥",
      LESS_THAN: "Less than <",
      LESS_THAN_OR_EQUAL: "Less than or equal ≤",
      EQUAL: "Equal =",
      BETWEEN: "Between",
    },
    validation: {
      required: "This field is required.",
      number: "Enter a valid number.",
      positive: "The value must be greater than zero.",
      maxAboveMin: "The maximum must be greater than the minimum.",
      humidityPair: "Enter both humidity limits, or leave both empty.",
      toAboveFrom: "The second value must be greater than the first.",
      targetsRequired: "Select at least one item.",
      geofencesRequired: "Select at least one geofence.",
      geofenceOnly: "This alert type can only be assigned to geofences.",
      daysRequired: "Please select at least one active day.",
      startTimeRequired: "Start Time is required.",
      endTimeRequired: "End Time is required.",
      endAfterStart: "End Time must be later than Start Time.",
      endDateAfterStart: "End Date can't be before Start Date.",
      recipientsRequired: "Select at least one recipient.",
    },
    unsavedChanges: {
      title: "Unsaved changes",
      message: "You have unsaved changes. Leave without saving?",
      stay: "Stay",
      leave: "Leave",
      close: "Close",
    },
  },
  edit: {
    title: "Edit Alert",
    subtitle: "Update the alert's rules, conditions, targets and schedule.",
    back: "Back to the alert",
    success: "Alert updated successfully.",
    loading: "Loading the alert",
    loadError: "Unable to load the alert. Please try again.",
    status: "Active",
    activateQuestion: "Are you sure you want to activate this alert?",
    deactivateQuestion: "Are you sure you want to deactivate this alert?",
    activateTitle: "Activate alert",
    deactivateTitle: "Deactivate alert",
    confirm: "Confirm",
    cancel: "Cancel",
    close: "Close",
  },
  history: {
    title: "Alert History",
    subtitle: "View and search the vehicles' past alerts.",
    search: "Search alert history",
    searchPlaceholder: "Search...",
    types: {
      SENSOR: "Sensor",
      SPEED: "Speed",
      DOWNTIME: "Downtime",
      ENTERED_GEOFENCE: "Entered geofence",
      EXITED_GEOFENCE: "Exited geofence",
    },
    table: {
      company: "Company",
      asset: "Asset name",
      alertName: "Alert name",
      alertType: "Alert type",
      triggeredValue: "Value",
      occurredAt: "Date & time",
      location: "Location",
      loading: "Loading alert history",
      total: "Total {{total}} alerts",
    },
    location: {
      unavailable: "Location is not available for this alert.",
      openInMaps: "Open {{coordinates}} in Google Maps",
    },
    filters: {
      filters: "Filters",
      company: "Company",
      allCompanies: "All companies",
      companySearch: "Search companies",
      companyEmpty: "No companies found.",
      asset: "Vehicle",
      allAssets: "All vehicles",
      assetSearch: "Search vehicles",
      assetEmpty: "No vehicles found.",
      alertType: "Alert type",
      all: "All",
      alertName: "Alert name",
      alertNamePlaceholder: "Type an alert name",
      sensor: "Sensor",
      allSensors: "All sensors",
      sensorSearch: "Search sensors",
      sensorEmpty: "No sensors found.",
      period: "Period",
      periodPlaceholder: "From date - To date",
      clearPeriod: "Clear period",
      nextMonth: "Next month",
      previousMonth: "Previous month",
      reset: "Reset",
      apply: "Apply",
    },
    empty: "No alerts found.",
    noMatch: "No alerts found for the selected criteria.",
    errorTitle: "Unable to load Alert History.",
    errorBody: "Please try again.",
    retry: "Retry",
    detail: {
      back: "Back to alert history",
      loading: "Loading the alert",
      loadError: "Unable to load the alert. Please try again.",
      notAvailable: "N/A",
      sections: {
        general: "Details",
        SPEED: "Speeding details",
        SENSOR: "Sensor alert details",
        DOWNTIME: "Downtime details",
        GEOFENCE: "Geofence details",
      },
      fields: {
        alertName: "Alert name",
        asset: "Asset name",
        company: "Company name",
        location: "Location",
        occurredAt: "Alert time",
        alertType: "Alert type",
        recordedSpeed: "Recorded speed",
        speedLimit: "Speed limit",
        sensor: "Sensor",
        sensorType: "Sensor type",
        triggeredValue: "Recorded value",
        unit: "Unit",
        condition: "Configured condition",
        duration: "Downtime",
        geofence: "Geofence name",
        geofenceEvent: "Event",
      },
      speed: "{{value}} km/h",
      minutes: "{{count}} min",
      // The configured condition, under the operators the history sends.
      conditions: {
        GREATER_THAN: "Greater than {{value}}",
        GREATER_THAN_OR_EQUAL: "Greater than or equal to {{value}}",
        LESS_THAN: "Less than {{value}}",
        LESS_THAN_OR_EQUAL: "Less than or equal to {{value}}",
        EQUAL: "Equal to {{value}}",
        BETWEEN: "Between {{value}} and {{valueTo}}",
        OUTSIDE_RANGE: "Outside {{value}} to {{valueTo}}",
        IS: "{{value}}",
      },
    },
  },
  permissions: {
    core: "Core",
    alertManagement: "Alert Management",
    alerts: "Alerts",
    log: "Alert History",
  },
};

export default alerts;
